module.exports = __webpack_public_path__ + "static/media/spotify_logo.321247fa.png";